// ===== Telas ainda não desenvolvidas =====
// Decisão do Kaio (30/09): pós-venda, SAC e financeiro ainda não estão prontos (e, no levantamento de 02/10, Ajustes
// e Webhooks, que mostravam configuração que não gravava)
// (o estado do pós-venda, por exemplo, vive só em memória e some no F5). Até
// ficarem, a rota mostra este aviso em vez de uma tela que parece pronta.
//
// O código das telas reais continua no app. Religar uma delas é apagar a entrada
// em TELAS_EM_DESENVOLVIMENTO; nada mais muda. O `Guard` de permissão fica na
// frente (app.jsx), então quem não tem acesso continua vendo "sem acesso".
import React from 'react';
import { Icon } from './icons.jsx';

const TELAS_EM_DESENVOLVIMENTO = {
  '/pos-venda': {
    titulo: 'Pós-venda',
    descricao: 'Acompanhamento dos negócios fechados até a entrega.',
  },
  '/sac': {
    titulo: 'SAC',
    descricao: 'Atendimento e ocorrências de pós-venda.',
  },
  '/financeiro': {
    titulo: 'Financeiro',
    descricao: 'Comissionamento, repasses e descontos.',
    // O Financeiro cai aqui ao entrar; o que já funciona para ele mora na ficha.
    dica: 'A % de repasse de um canal já pode ser definida na ficha do cliente, em Clientes.',
  },
  // Levantamento de 02/10: a tela dizia "salvo automaticamente" e NADA gravava (tudo vivia em memória), e mostrava
  // "desconto máximo sem aprovação" e "tabela padrão" como regras que nenhum código aplica. Quem lê acredita.
  '/ajustes': {
    titulo: 'Ajustes',
    descricao: 'Tabelas de preço, transportadoras e padrões da proposta.',
    dica: 'Estas configurações ainda não são gravadas, e por isso a tela não está disponível. Os padrões da proposta seguem os valores de fábrica.',
  },
  // Criar webhook só mexia na memória (e nada disparava para fora).
  '/webhooks': {
    titulo: 'Webhooks',
    descricao: 'Avisos automáticos a sistemas externos.',
  },
};

// Pergunta única que o selo do menu, o botão escondido e o aviso da rota fazem. Lê o mapa na hora
// da chamada: apagar a entrada de TELAS_EM_DESENVOLVIMENTO religa tudo junto.
function estaEmDesenvolvimento(rota) {
  return Boolean(TELAS_EM_DESENVOLVIMENTO[rota]);
}

function TelaEmDesenvolvimento({ titulo, descricao, dica }) {
  return (
    <div className="main" data-screen-label={titulo} data-em-desenvolvimento="true">
      <div style={{ maxWidth: 480, margin: '72px auto', padding: '0 20px', textAlign: 'center' }}>
        <div
          style={{
            width: 56, height: 56, borderRadius: '50%', margin: '0 auto 16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'var(--color-accent-soft)', color: 'var(--color-accent-deep)',
          }}
        >
          <Icon name="wrench" size={24} />
        </div>
        <h2 style={{ margin: '0 0 6px', fontSize: 20, color: 'var(--color-ink)' }}>Tela em desenvolvimento</h2>
        <p style={{ margin: '0 0 14px', fontSize: 14, color: 'var(--color-ink)' }}>
          {titulo} ainda não está disponível.
        </p>
        <p style={{ margin: '0 0 14px', fontSize: 13, color: 'var(--color-ink-soft)' }}>{descricao}</p>
        {dica ? (
          <p data-dica="true" style={{ margin: '0 0 14px', fontSize: 13, color: 'var(--color-ink-soft)' }}>{dica}</p>
        ) : null}
        <p style={{ margin: '0 0 18px', fontSize: 13, color: 'var(--color-ink-soft)' }}>
          O restante do CRM continua funcionando normalmente.
        </p>
        <a className="btn" href="#/">Voltar ao início</a>
      </div>
    </div>
  );
}

// Ponto único de troca das rotas: devolve o aviso se a tela está em desenvolvimento
// e a própria tela real nos demais casos.
function telaOuEmDesenvolvimento(rota, telaReal) {
  if (!estaEmDesenvolvimento(rota)) return telaReal;
  const t = TELAS_EM_DESENVOLVIMENTO[rota];
  return <TelaEmDesenvolvimento titulo={t.titulo} descricao={t.descricao} dica={t.dica} />;
}

export { TelaEmDesenvolvimento, TELAS_EM_DESENVOLVIMENTO, estaEmDesenvolvimento, telaOuEmDesenvolvimento };
